// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lad-itinerary-download--dialog .el-dialog__body-wrapper{padding:0}.lad-itinerary-download--dialog .el-dialog{margin-top:5vh!important;height:90vh}.lad-itinerary-download--dialog .lad-zoho .el-main{margin-bottom:0}.lad-itinerary-download--dialog .lad-zoho--header{padding-top:0}.lad-itinerary-download--dialog .itinerary-download-btn{text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
